import { render, staticRenderFns } from "./ForgotPasswd.vue?vue&type=template&id=501cd9c2&"
import script from "./ForgotPasswd.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswd.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswd.vue?vue&type=style&index=0&id=501cd9c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports